import { z } from "zod";

export enum FriendshipStatus {
	None,
	Pending,
	Accepted,
	Declined,
}
export enum InvitationPolicy {
	Friends,
	Anyone,
	Nobody,
}
export enum SocialActivity {
	Offline,
	Online,
	Exploring,
	PlayingCards,
	Editing,
}
export const socialPreferencesSchema = z.object({
	appearOffline: z.boolean(),
	shareActivity: z.boolean(),
	invitations: z.enum(InvitationPolicy),
});
export type SocialPreferences = z.infer<typeof socialPreferencesSchema>;
export const defaultSocialPreferences: SocialPreferences = {
	appearOffline: false,
	shareActivity: true,
	invitations: InvitationPolicy.Friends,
};
export interface PlayerSocialProfile {
	_id: string;
	schemaVersion: 1;
	tag: string;
	preferences: SocialPreferences;
}
export interface SocialTag {
	_id: string;
	userId: string;
}
export interface Friendship {
	_id: string;
	schemaVersion: 1;
	users: [string, string];
	requester: string;
	status: FriendshipStatus;
	blockedBy: string[];
	blockVersion?: number;
	createdAt: number;
	updatedAt: number;
	requestReadAt?: number;
}
export interface SocialIndex {
	_id: string;
	schemaVersion: 1;
	peers: string[];
	pendingOutgoing?: string[];
}
export interface PublicSocialProfile {
	id: string;
	tag: string;
	name: string;
	avatarUrl: string | null;
}
export interface SocialRelationshipView {
	profile: PublicSocialProfile;
	status: FriendshipStatus;
	incoming: boolean;
	unread: boolean;
	requestCreatedAt?: number;
	blocked: boolean;
	activity: SocialActivity;
}
export interface SocialOverview {
	self: PublicSocialProfile;
	preferences: SocialPreferences;
	relationships: SocialRelationshipView[];
}
